import { Outlet, Navigate } from "react-router-dom";

const RouteGuard = ({ isAuthenticated }) => {
  if (isAuthenticated === null) return `...LOADING...`;
  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default RouteGuard;
